export { default as FolderXSolidIcon } from './FolderXSolidIcon';
